module.exports = __webpack_public_path__ + "static/media/il-resume@3x.898ed1bb.png";